export const CollectionExportPolicy = {
	/**
	 * Maximum number of collections allowed to be exported at one time.
	 *
	 * Limit in place to reduce load on servers.
	 */
	MAX_LIMIT: 2500,
};
